import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { create } from "lodash";
import * as arrivalAPI from "../../api/arrival";
import { toast } from "react-toastify";

const initialState = {
  loading: false,
  activeArrivals: null,
  newArrivalList: [],
  redirect: false,
  perPage: 10,
  page: 1,
  offset: 0,
};

const addNewArrival = createAsyncThunk(
  "/add/book",
  async (params, { rejectWithValue }) => {
    try {
      const payload = {
        author: params?.author,
        title: params?.title,
        arrivalDate: params?.arrivalDate,
        institutionId:params?.institutionId,
      };
      const res = await arrivalAPI.addNewArrival(payload);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      } else {
        toast.success("Books Details Uploaded Successfully");
      }
      return res.data;
    } catch (error) {}
  }
);

const getNewArrival = createAsyncThunk(
  "/get/books",
  async (params, { rejectWithValue }) => {
    try {
      const res = await arrivalAPI.getNewArrival(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      } else {
      }
      return res.data.body;
    } catch (error) {}
  }
);

const deleteArrival = createAsyncThunk(
  "/delete/book",
  async (params, { rejectWithValue }) => {
    try {
      const res = await arrivalAPI.deleteArrival(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      } else {
      }
      return res.data;
    } catch (error) {}
  }
);
const updateArrival = createAsyncThunk(
  "/update/book",
  async (params, { rejectWithValue }) => {
    try {
      const res = await arrivalAPI.updateArrival(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      } else {
      }
      return res.data;
    } catch (error) {}
  }
);
const arrivalSlice = createSlice({
  name: "arrivalSlice",
  initialState,
  reducers: {
    setActiveArrivals: (state, action) => {
      //console.log(action.payload, 'action23')
      state.activeArrivals = action.payload;
    },

    setRedirection: (state, action) => {
      state.redirect = action.payload;
    },
    setPerPage: (state, action) => {
      state.perPage = action.payload;
    },
    setOffset: (state, action) => {
      state.offset = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getNewArrival.fulfilled, (state, action) => {
        // toast.success(action.payload.body.success);

        return { ...state, newArrivalList: action.payload };
      })
      .addCase(deleteArrival.fulfilled, (state, action) => {
        toast.success(action.payload.body);
      })
      .addCase(updateArrival.fulfilled, (state, action) => {
        toast.success(action.payload.body);
      });
  },
});

const { setActiveArrivals, setRedirection, setPerPage,
  setOffset,
  setPage, } = arrivalSlice.actions;
export default arrivalSlice.reducer;
export {
  addNewArrival,
  getNewArrival,
  updateArrival,
  deleteArrival,
  setActiveArrivals,
  setRedirection,
  setPerPage,
  setOffset,
  setPage,
};
